import { render, staticRenderFns } from "./ProceduresModal.vue?vue&type=template&id=74ae4a4b&scoped=true&"
import script from "./ProceduresModal.ts?vue&type=script&lang=ts&"
export * from "./ProceduresModal.ts?vue&type=script&lang=ts&"
import style0 from "./ProceduresModal.scss?vue&type=style&index=0&id=74ae4a4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ae4a4b",
  null
  
)

export default component.exports